import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from "@headlessui/react";
import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Option } from "@/components/command-menu/Option";

import type { CommandMenuStore, MenuCommand } from "@/components/command-menu/CommandMenuStore";

export const CommandMenu = observer(function CommandMenu({ store }: { store: CommandMenuStore }) {
  const t = useTranslations("commandMenu");

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Escape") {
      event.preventDefault();
      store.closeDialog();
    }
  };

  const handleOnChange = (command?: MenuCommand) => {
    if (command) {
      store.selectCommand(command);
    }
  };

  return (
    <Combobox as="div" className="relative" onChange={handleOnChange}>
      <div className="z-20 -left-[5px] min-w-[260px] max-w-[640px] top-full overflow-auto no-scrollbar flex flex-col rounded-10 mt-2 p-1.5 bg-block-bg shadow-md dark:shadow-block-inverted cursor-default">
        <ComboboxInput
          className="w-full border-none py-2 pl-3 pr-10 outline-none"
          placeholder={t("placeholder")}
          autoComplete="off"
          autoFocus
          data-1p-ignore="true"
          onKeyDown={handleKeyDown}
          onChange={(event) => store.setFilterQuery(event.target.value)}
        />
        <ComboboxOptions static>
          {store.commands.length === 0 ? (
            <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
              {t("nothingFound")}
            </div>
          ) : (
            store.commands.map((command) => (
              <ComboboxOption key={command.name} value={command}>
                {({ focus }) => (
                  <Option title={command.name} icon={command.icon} isActive={focus} />
                )}
              </ComboboxOption>
            ))
          )}
        </ComboboxOptions>
      </div>
    </Combobox>
  );
});
